import NonProfitOrganizationList from '@/components/npo/NonProfitOrganizationsList';
import { useScrollListener } from '@/hooks/useScrollListener';

const Churches = () => {
  const { scrollEnabled, scrollHandler } = useScrollListener();

  return <NonProfitOrganizationList npoType="CHURCH" onScroll={scrollHandler} scrollEnabled={scrollEnabled} />;
};

export default Churches;
